import type { StripoMergeField } from './stripo.types';

export const TEMPLATE_MERGE_FIELDS: StripoMergeField[] = [
  {
    category: 'Standard Customer Fields',
    entries: [
      { label: 'First Name', value: '{{First Name}}' },
      { label: 'Last Name', value: '{{Last Name}}' },
      { label: 'Email', value: '{{Email}}' },
      { label: 'Phone', value: '{{Phone}}' },
    ],
  },
  {
    category: 'Custom Fields',
    entries: [
      { label: 'Birthday', value: '{{Birthday}}' },
      { label: 'Lifetime Value', value: '{{Lifetime Value}}' },
      { label: 'Pet Type', value: '{{Pet Type}}' },
      { label: 'Last Purchase Date', value: '{{Last Purchase Date}}' },
      { label: 'Loyalty Tier', value: '{{Loyalty Tier}}' },
    ],
  },
  {
    category: 'Business Fields',
    entries: [
      { label: 'Company Name', value: '[[company_name]]' },
      { label: 'Company Website', value: '[[company_website]]' },
      { label: 'Company Email', value: '[[company_email]]' },
      { label: 'Company Phone', value: '[[company_phone]]' },
      { label: 'Company Logo URL', value: '[[company_logo_url]]' },
      { label: 'Company External ID', value: '[[company_external_id]]' },
      { label: 'Company Primary Color', value: '[[company_primary_color]]' },
    ],
  },
];

export const TEMPLATE_MERGE_FIELDS_PLACEHOLDERS: string[] = TEMPLATE_MERGE_FIELDS.reduce(
  (acc, category) => {
    return [...acc, ...category.entries.map(entry => entry.value)];
  },
  [] as string[],
);
